import {create} from "zustand";

type NotificationsStore = {
    hasNewNotifications: boolean;
    setHasNewNotifications: (hasNew: boolean) => void;
};

export const useNotificationsStore = create<NotificationsStore>((set) => ({
    hasNewNotifications: false,
    setHasNewNotifications: (hasNew: boolean) =>
        set({hasNewNotifications: hasNew}),
}));

export default useNotificationsStore;
